/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 7b2fe95ec3eacb5d14fe3cf37b870fdd */

import { ConcreteRequest } from "relay-runtime";

import {  } from "relay-runtime";
export type SearchBarRefetchQueryVariables = {
    query: string;
    hasQuery: boolean;
    userId: string;
    hasUserId: boolean;
    localRecentHistoryItemIds?: Array<string | null> | null | undefined;
    fetchUserRecentHistoryItem?: boolean | null | undefined;
};
export type SearchBarRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"SearchBar_viewer">;
    };
};
export type SearchBarRefetchQuery = {
    readonly response: SearchBarRefetchQueryResponse;
    readonly variables: SearchBarRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "fetchUserRecentHistoryItem"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasQuery"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasUserId"
    } as any, v3 = {
        "defaultValue": ([] /*: any*/),
        "kind": "LocalArgument",
        "name": "localRecentHistoryItemIds"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    } as any, v6 = {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v8 = [
        {
            "kind": "Variable",
            "name": "excludeItemPks",
            "variableName": "localRecentHistoryItemIds"
        } as any,
        {
            "kind": "Literal",
            "name": "first",
            "value": 12
        } as any
    ], v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceId",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "SearchBarRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "hasQuery",
                                    "variableName": "hasQuery"
                                },
                                (v6 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "SearchBar_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v4 /*: any*/),
                (v1 /*: any*/),
                (v5 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "SearchBarRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "condition": "hasQuery",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "includeTypes",
                                            "value": [
                                                "POPULAR",
                                                "CATEGORY",
                                                "SELLER",
                                                "CREATOR"
                                            ]
                                        },
                                        (v6 /*: any*/)
                                    ],
                                    "concreteType": "SearchSuggestion",
                                    "kind": "LinkedField",
                                    "name": "searchSuggestions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SearchSuggestionList",
                                            "kind": "LinkedField",
                                            "name": "suggestions",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "type",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SearchSuggestionTerm",
                                                    "kind": "LinkedField",
                                                    "name": "terms",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "term",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "urlLabel",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "condition": "hasUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "userId",
                                            "variableName": "userId"
                                        }
                                    ],
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "if": null,
                                            "kind": "Defer",
                                            "label": "SearchBar_viewer$defer$getRecentHistory_user",
                                            "selections": [
                                                {
                                                    "condition": "fetchUserRecentHistoryItem",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": (v8 /*: any*/),
                                                            "concreteType": "RecentHistoryItemsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "recentHistoryItems",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "RecentHistoryItemsEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Item",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "contemporaryTrackingString",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "size",
                                                                                            "value": "small"
                                                                                        }
                                                                                    ],
                                                                                    "kind": "ScalarField",
                                                                                    "name": "firstPhotoWebPath",
                                                                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pdpURL",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "browseUrl",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "categoryCode",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v9 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "categoryPath",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Seller",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "seller",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v9 /*: any*/),
                                                                                        (v7 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v7 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "cursor",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "endCursor",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "hasNextPage",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v8 /*: any*/),
                                                            "filters": [
                                                                "excludeItemPks"
                                                            ],
                                                            "handle": "connection",
                                                            "key": "getRecentHistory_recentHistoryItems",
                                                            "kind": "LinkedHandle",
                                                            "name": "recentHistoryItems"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/SearchBarRefetchQuery",
            "metadata": {},
            "name": "SearchBarRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '7beead14353d8fc89775b3c15627bd25';
export default node;
